import makeExternalTab from './makeExternalTab';

const dynamicsTabs = (orgId, userId) => [
  makeExternalTab({
    label: 'DS Management',
    url: '/legacy/ds-management',
    src: `https://webadmin-dynamics.dialsource.com/settings/${orgId}/${userId}/0`,
  }),

  makeExternalTab({
    label: 'DS Admin',
    url: '/legacy/ds-admin',
    src: `https://webadmin-dynamics.dialsource.com/admin/managerRecordings/${orgId}/${userId}/dynamics/0/dynamics`,
  }),

  makeExternalTab({
    label: 'DS User',
    url: '/legacy/ds-user',
    src: `https://webadmin-dynamics.dialsource.com/user/voicemailRecordings/${orgId}/${userId}/dynamics/0/dynamics-crm/dynamics`,
  }),
];

export default dynamicsTabs;
